import React from 'react';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import { CorporateCreatePage } from 'src/components/enterprise/features/Corporate/CreatePage/CorporateCreatePage';
import { CorporateEditPage } from 'src/components/enterprise/features/Corporate/EditPage/CorporateEditPage';

const CorporateCreatePageLayout = withEnterpriseLayout(CorporateCreatePage);
const CorporateEditPageLayout = withEnterpriseLayout(CorporateEditPage);

export const CorporateCreateRoute = (): JSX.Element => (
  <CorporateCreatePageLayout pageTitle="Add New Client" />
);

export const CorporateEditRoute = (): JSX.Element => (
  <CorporateEditPageLayout pageTitle="Edit Client" />
);
